import styled from 'styled-components';

export const ProfessionalSloganStyled = styled.div`
  width: 100%;
  padding: 30px 20px;
`;

export const ContainerStyled = styled.div`
  max-width: 1450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    gap: 80px;
  }
  .main-text {
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 0 20px;

    & .text {
      font-size: 20px;
      line-height: 32px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 29px;
        line-height: 45px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 32px;
        line-height: 50px;
      }
    }
    & .title {
      line-height: 25px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        line-height: 27px;
      }
    }
  }
  .img {
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      width: 480px;
    }
  }
`;
